import { z } from 'zod';
import { ReactionType } from './engagement.js';
/**
 * In-app notifications (FR-NOTF). `seen` clears the bell badge when the list
 * opens; `read` is per-row and survives it (AC-NOTF-01…06.7) — two flags, not
 * one, by design.
 */
export const NotificationType = z.enum([
    'comment',
    'opv',
    'reaction',
    'family_request',
    'family_accepted',
    'family_award_consent',
    'family_award_submitted',
    'connection_request',
    'connection_accepted',
    'new_supporter',
    'community_request',
    'community_approved',
    'community_invite',
    'message',
    'donation',
    'admin',
    'bucket_reminder',
]);
export const NotificationView = z.object({
    id: z.string(),
    type: NotificationType,
    actorId: z.string(),
    targetType: z.string(),
    targetId: z.string(),
    contextId: z.string().optional(),
    /** Set for type 'reaction'. */
    reactionType: ReactionType.optional(),
    seen: z.boolean(),
    read: z.boolean(),
    createdAt: z.coerce.date(),
});
export const UnreadCount = z.object({ count: z.number().int().nonnegative() });
export const DeletedNotification = z.object({ id: z.string() });
//# sourceMappingURL=notifications.js.map